import { userService } from '@/_services'

export const $_user_role = {
  admin: 'ADMIN',
  developer: 'DEVELOPER',

  judge: 'JUDGE',
  judgeHelper: 'JUDGEHELPER',
  limitjudge: 'LIMITJUDGE',

  postworker: 'POSTWORKER',

  knowledge: 'KNOWLEDGE',
  
  specialist: 'SPECIALIST',
  accountant: 'ACCOUNTANT',
  headofdepartment: 'HEADOFDEPARTMENT',

  chairman: 'CHAIRMAN',
  distributionOperator: {
    administrative: 'DISTRIBUTION_A', //  Оператор распределения (Адм.)
    civil:          'DISTRIBUTION_G', //  Оператор распределения (Гр.)
    criminal:       'DISTRIBUTION_U', //  Оператор распределения (Уг.)
  }
}

export const $_user_utils = {
  methods: {
    $user_utils_goToStartPage() {
      if (this.$store.state.route) {
        this.$router.push(this.$store.state.route)
      }
      else if (userService.hasRole([$_user_role.judge]) 
               || userService.hasRole([$_user_role.judgeHelper]) 
               || userService.hasRole([$_user_role.limitjudge])) {
          this.$store.dispatch('judge/GET_JUDGE')
          if (window.settings.limitMenu && window.settings.limitMenu.available==true) 
            this.$router.push('/'+window.settings.limitMenu.start)
          else
            this.$router.push('/case')
      } 
      else if(userService.hasRole([$_user_role.specialist])){
          this.$store.dispatch('specialist/LOAD_AUTH_SPEC')
          .then(spec => {
            if (spec.specialistType.value==0)
              this.$router.push('/specialist/advocat/apps')
            else if (spec.specialistType.value==1)
              this.$router.push('/specialist/profile')
          })
      } 
      else if (userService.hasRole([$_user_role.postworker])){
        this.$router.push('/post/letters')
      } 
      else if (userService.hasRole([$_user_role.admin])){
        this.$router.push('/admin/users')
      } 
      else if (userService.hasRole([$_user_role.accountant])){
        this.$router.push('/specialist/apps')
      } 
      else if (userService.hasRole([$_user_role.headofdepartment])){
        this.$router.push('/specialist/reestr')
      } 
      else if (userService.hasRole([$_user_role.developer])){
        this.$router.push('/case')
      } 
      else if (userService.hasRole([$_user_role.knowledge])){
        this.$router.push('/knowledgebase')
      } 
      else if (userService.hasRole([$_user_role.distributionOperator.civil])
               || userService.hasRole([$_user_role.distributionOperator.administrative])
               || userService.hasRole([$_user_role.distributionOperator.criminal])
               || userService.hasRole([$_user_role.chairman])) {
        this.$router.push('/admin/distribution')
      } 
    },
    $user_utils_checkAccess() {
      if (localStorage.getItem("courtAlias") == null) return false

      if ( localStorage.getItem("courtAlias")!='' && localStorage.getItem("grants").indexOf(localStorage.getItem("courtAlias")) != -1 )
        return true
      else if ( localStorage.getItem("courtAlias")=='' || userService.hasRole([$_user_role.specialist])) 
        return true
      else
        return false
    }
  }
}

